export type OfertaLaboral = {
  oferta_id: string;
  titulo: string;
  empresa: string;
  ubicacion?: string;
  modalidad?: 'Presencial' | 'Híbrido' | 'Remoto';
  tipo?: 'Full-time' | 'Part-time' | 'Contrato' | 'Pasantía';
  categorias?: string[];
  descripcion: string;
  contacto: string;
  activo: boolean;
  publicado_en: string;
};

const STORAGE_KEY = 'bolsa_trabajo_ofertas';

const seed: OfertaLaboral[] = [
  {
    oferta_id: '1',
    titulo: 'Vendedor/a de salón',
    empresa: 'Comercio Local SRL',
    ubicacion: 'San Carlos de Bolívar',
    modalidad: 'Presencial',
    tipo: 'Full-time',
    categorias: ['Comercio', 'Mostrador'],
    descripcion: 'Atención al cliente, manejo de caja y reposición de mercadería.',
    contacto: 'rrhh@comerciolocal.com',
    activo: true,
    publicado_en: new Date().toISOString(),
  },
];

const read = (): OfertaLaboral[] => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(seed));
    return seed;
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : seed;
  } catch {
    return seed;
  }
};

const write = (items: OfertaLaboral[]) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

export const getOfertasLaborales = async (soloActivas = false) => {
  const items = read();
  return soloActivas ? items.filter((o) => o.activo !== false) : items;
};

export const createOfertaLaboral = async (payload: Omit<OfertaLaboral, 'oferta_id' | 'publicado_en'>) => {
  const items = read();
  const created: OfertaLaboral = {
    ...payload,
    oferta_id: String(Date.now()),
    publicado_en: new Date().toISOString(),
  };
  write([created, ...items]);
  return created;
};

export const updateOfertaLaboral = async (oferta_id: string, payload: Partial<OfertaLaboral>) => {
  const items = read().map((o) => (o.oferta_id === oferta_id ? { ...o, ...payload } : o));
  write(items);
  return items.find((o) => o.oferta_id === oferta_id);
};

export const deleteOfertaLaboral = async (oferta_id: string) => {
  const items = read().filter((o) => o.oferta_id !== oferta_id);
  write(items);
};
